import { render, staticRenderFns } from "./ManualDraw.vue?vue&type=template&id=05980abf&scoped=true"
import script from "./ManualDraw.vue?vue&type=script&lang=js"
export * from "./ManualDraw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05980abf",
  null
  
)

export default component.exports